import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import MultilingualProductForm from "./MultilingualProductForm";
import { useGetProductByIdQuery, useUpdateProductMutation } from "../../redux/api/productsApi";
import { useGetManufacturersQuery } from "../../redux/api/manufacturersApi";
import { toast } from "react-toastify";

const EditProductPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const { data: product, isLoading: productLoading, error: productError } = useGetProductByIdQuery(id);
  const { data: manufacturers = [], isLoading: manufacturersLoading } = useGetManufacturersQuery();
  const [updateProduct] = useUpdateProductMutation();

  const loading = productLoading || manufacturersLoading;
  const error = productError;

  const handleUpdateProduct = async (updatedData) => {
    try {
      await updateProduct({
        ...updatedData,
        id: parseInt(id),
      }).unwrap();
      toast.success("Product updated successfully!");
      // Return the existing product ID for metadata saving
      return { product_id: parseInt(id) };
    } catch (err) {
      toast.error(err?.data?.message || err?.error || "Failed to update product");
      throw err;
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error?.data?.message || error?.error || 'Failed to load product'}</p>;
  if (!product) return <p>Product not found</p>;

  return (
    <div>
      <h1 className="mb-4">Edit Product</h1>
      <MultilingualProductForm
        product={product}
        manufacturers={manufacturers}
        onSubmit={handleUpdateProduct}
        onSuccess={() => navigate("/products")}
      />
    </div>
  );
};

export default EditProductPage;
